import { render, staticRenderFns } from "./borrow-info.vue?vue&type=template&id=efd31922&scoped=true"
import script from "./borrow-info.vue?vue&type=script&lang=js"
export * from "./borrow-info.vue?vue&type=script&lang=js"
import style0 from "./borrow-info.vue?vue&type=style&index=0&id=efd31922&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd31922",
  null
  
)

export default component.exports